import { startsWith } from '../../utils/lang';
export function startsWithMatcherContext(ruleAttr) {
  return function startsWithMatcher(runtimeAttr) {
    var matches = ruleAttr.some(function (e) {
      return startsWith(runtimeAttr, e);
    });
    return matches;
  };
}